const PREFIX = "create-account_";
const ON_LOAD = "onload";
const CLICK = "click";

export const RegisterModalDatameshIds = {
  onLoad: {
    social: `${PREFIX}${ON_LOAD}:google`,
    edo: `${PREFIX}${ON_LOAD}:edo`,
    login: `${PREFIX}${ON_LOAD}:login`,
  },
  onClick: {
    social: `${PREFIX}${CLICK}:google`,
    privacyPolicy: `${PREFIX}${CLICK}:privacy-policy`,
    termsConditions: `${PREFIX}${CLICK}:terms-conditions`,
    email: `${PREFIX}${CLICK}:email`,
    login: `${PREFIX}${CLICK}:login`,
  },
  onError: {
    emailFormat: `${PREFIX}email_error`,
    passwordFormat: `${PREFIX}password-format_error`,
    connectionError: `${PREFIX}password-connection_error`,
    genericError: `${PREFIX}password_error`,
  },
};
export enum RegisterVerificationDatameshIds {
  onLoad = "verification-email_onload",
  onClick = "verification-email_click",
}
